import {
  doc,
  getDoc,
  getDocs,
  collection
} from 'firebase/firestore';
import { firestore } from '../helpers/firebase';

export const getDraftDetails = async () => {
  const year = new Date().getFullYear().toString();
  return getDraftDetailsForYear(year);
};

export const getDraftDetailsForYear = async (year) => {
  const minimumDraftInfo = {
    draftInfoDue: null,
    draftDate: null,
    draftOrder: [],
    draftLinks: [],
    disabled: true,
    forceOpen: false,
  };
  const returnDraftDetails = await getDoc(doc(firestore, 'draft', year))
    .then(snapshot => (snapshot.exists() ? ({ success: true, ...minimumDraftInfo, ...snapshot.data() }) : ({ success: true, ...minimumDraftInfo })))
    .catch(error => ({ success: false, ...minimumDraftInfo, error }));
  return returnDraftDetails;
};

export const getDraftYears = async () => getDocs(collection(firestore, 'draft'))
  .then((snapshot) => ({
    error: false,
    draftYears: snapshot.docs.map((draftDoc) => draftDoc.id).sort((leftYear, rightYear) => Number(rightYear) - Number(leftYear)),
  }))
  .catch((error) => ({
    error: true,
    message: error.message,
    draftYears: [],
  }));

export default getDraftDetails;
